import { Outlet, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const linkBase = "px-2 py-1 text-[11px] font-medium tracking-[0.24em] uppercase transition-colors duration-300";
const linkInactive = "text-[#1F3E42]/70 hover:text-[#006A71]";
const linkActive = "text-[#006A71] border-b border-[#006A71]";

export default function Layout() {
  const [wedding, setWedding] = useState({ bride: "Lien", groom: "Gust" });
  const location = useLocation();

  useEffect(() => {
    api.get("/wedding").then((r) => setWedding(r.data)).catch(() => {});
  }, [location.pathname]);

  const navItems = [
    { to: "/", label: "Welkom", key: "welcome" },
    { to: "/de-bende", label: "De Bende", key: "bende" },
    { to: "/wensen", label: "Wensen", key: "wishes" },
  ];

  return (
    <div className="min-h-screen paper-grain relative">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-[#FAF6EF]/85 border-b border-[#1F3E42]/10">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-4">
          <NavLink to="/" className="flex items-center gap-1 group" data-testid="nav-home-link">
            <span className="font-script text-3xl text-[#006A71] leading-none">
              {wedding.bride} <span className="text-[#006A71]">&</span> {wedding.groom}
            </span>
          </NavLink>
          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.key}-link`}
                className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="relative z-10">
        <Outlet />
      </main>
      <footer className="border-t border-[#1F3E42]/10 mt-24 py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="font-script text-3xl text-[#006A71]">Con amore</p>
          <div className="section-divider mt-4"><span className="section-divider-dot" /></div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#1F3E42]/60 mt-2">
            Een digitaal cadeau voor {wedding.bride} & {wedding.groom}
          </p>
        </div>
      </footer>
    </div>
  );
}
